import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-jumbotron-example',
  templateUrl: './jumbotron.component.html',
})
export class KitBootstrapJumbotronExampleComponent {}
